import React, { useState } from 'react';
import { IonCard, IonCardContent, IonList, IonItem, IonLabel, IonButton, IonGrid, IonRow, IonCol } from '@ionic/react';
import CommentModal from './CommentModal';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { updateComment, deleteComment } from '../../actions/post';
import { formatDistanceToNow } from 'date-fns';
import { toast } from '../../helpers/toast';

const PostComment = ({ updateComment, deleteComment, user, comment, post }) => {
  const [showModal, setShowModal] = useState(false);
  const [isAuthUser] = useState(Boolean(comment.user === user));

  function handleCloseModal() {
    setShowModal(false);
  }

  function handleEdit(commentText) {
    setShowModal(true);
    const editData = {
      text: commentText,
    };
    updateComment(post, comment._id, editData);

    window.location.reload();
    toast('Comment has been edited successfully');
    setShowModal(false);
  }

  function handleDelete() {
    deleteComment(post, comment._id);
    toast('Comment has been successfully deleted');
  }

  return (
    <>
      <CommentModal
        isOpen={showModal}
        title='Edit Comment'
        sendAction={handleEdit}
        closeAction={handleCloseModal}
        comment={comment}
      />
      <IonCard>
        <IonCardContent class=''>
          <IonList lines='none'>
            <IonItem>
              <IonGrid>
                <IonRow>
                  <IonCol class='ion-text-wrap' className='ion-align-self-end'>
                    <div>{comment.text}</div>
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol style={{ textAlign: 'left' }}>
                    <p>
                      <IonLabel color='medium'>
                        {comment.name} <br />
                        <em>commented {formatDistanceToNow(new Date(comment.date)) + ' ago'}</em>
                      </IonLabel>
                    </p>
                  </IonCol>
                  <IonCol style={{ textAlign: 'right' }}>
                    {isAuthUser && (
                      <IonButton size='small' onClick={() => setShowModal(true)}>
                        Edit
                      </IonButton>
                    )}
                    {isAuthUser && (
                      <IonButton size='small' color='danger' onClick={handleDelete}>
                        Delete
                      </IonButton>
                    )}
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonItem>
          </IonList>
        </IonCardContent>
      </IonCard>
    </>
  );
};

PostComment.propType = {
  updateComment: PropTypes.func.isRequired,
  deleteComment: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  comment: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => ({
  user: props.user,
  comment: props.comment,
  post: props.post,
});

export default connect(mapStateToProps, { updateComment, deleteComment })(withRouter(PostComment));
